import { motion } from "framer-motion";
import {
  MonitorSmartphone,
  TerminalSquare,
  FolderSync,
  MonitorPlay,
  Power,
  ShieldCheck,
} from "lucide-react";
import { EASE, Overline, Reveal } from "@/components/motion";

const FEATURES = [
  {
    icon: MonitorSmartphone,
    title: "Uzaktan Masaüstü Erişimi",
    desc: "Tarayıcıdan tam kontrol: klavye, fare ve pano senkronizasyonuyla çoklu monitör desteği. Sanki cihazın başındaymışsınız gibi çalışın.",
    num: "01",
    span: "lg:col-span-2",
  },
  {
    icon: TerminalSquare,
    title: "Uzak Terminal",
    desc: "PowerShell, Bash veya CMD — desteklediğimiz tüm işletim sistemlerinde uzaktan komut satırı çalıştırın.",
    num: "02",
    span: "",
  },
  {
    icon: FolderSync,
    title: "Dosya Yöneticisi",
    desc: "Sürükle-bırak ile çift yönlü, boyut sınırı olmayan güvenli dosya aktarımı.",
    num: "03",
    span: "",
  },
  {
    icon: MonitorPlay,
    title: "Oturum Kaydı ve Denetim",
    desc: "Masaüstü ve terminal oturumlarını kaydedin; tüm işlemler JSON, syslog veya SIEM'e aktarılabilir kayıtlarla izlensin.",
    num: "04",
    span: "",
  },
  {
    icon: Power,
    title: "Uzak Güç ve Intel AMT",
    desc: "Wake-on-LAN ve Intel AMT ile işletim sistemi kapalıyken bile cihazı açın, BIOS'a erişin, donanım seviyesinde yönetin.",
    num: "05",
    span: "",
  },
  {
    icon: ShieldCheck,
    title: "Güvenlik ve 2FA",
    desc: "WebRTC ile doğrudan şifreli bağlantı, çok faktörlü kimlik doğrulama ve kullanıcı bazlı yetkilendirme ile tam denetim.",
    num: "06",
    span: "lg:col-span-2",
  },
];

export default function Features() {
  return (
    <section id="ozellikler" data-testid="features-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-16 max-w-2xl md:mb-24">
          <Reveal>
            <Overline>Yetenekler</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl font-bold tracking-tighter text-[#0A0A0A] sm:text-5xl lg:text-6xl">
              Sahada olmadan,
              <br />
              <span className="text-[#003366]">sahadaymış gibi.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base leading-relaxed text-[#525252] md:text-lg">
              BT ekiplerinin ihtiyaç duyduğu her araç, tek platformda.
              Altı temel yetenek, sıfır karmaşa.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <motion.article
              key={f.num}
              data-testid={`feature-card-${f.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.1, ease: EASE }}
              whileHover={{ y: -6 }}
              className={`group relative overflow-hidden rounded-3xl border border-black/5 bg-white p-8 transition-colors duration-500 hover:border-[#003366]/20 md:p-10 ${f.span}`}
            >
              <span
                className="font-display pointer-events-none absolute -right-3 -top-6 text-[7rem] font-bold leading-none text-outline transition-all duration-500 group-hover:-translate-y-1 md:text-[9rem]"
                aria-hidden="true"
              >
                {f.num}
              </span>
              <div className="relative">
                <div className="mb-8 inline-flex rounded-2xl border border-[#003366]/10 bg-[#FAFAFA] p-3.5 transition-colors duration-500 group-hover:bg-[#003366]">
                  <f.icon
                    className="h-6 w-6 text-[#003366] transition-colors duration-500 group-hover:text-white"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-display text-xl font-bold tracking-tight text-[#0A0A0A] md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-[#525252] md:text-base">
                  {f.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
